import { getIdToken } from './auth';

const API = import.meta.env.VITE_API_URL || 'https://api.scrivar.com';

async function authed(path, options = {}) {
  const token = await getIdToken();
  if (!token) throw new Error('Not signed in');
  const res = await fetch(`${API}${path}`, { ...options, headers: { ...(options.headers || {}), Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error(`Request failed (${res.status})`);
  return res.json();
}

export const notificationsApi = {
  list: () => authed('/notifications'),
  markRead: (id) => authed(`/notifications/${id}/read`, { method: 'POST' }),
  markAllRead: () => authed('/notifications/read-all', { method: 'POST' }),
};
